import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "c-co-table" }
const _hoisted_2 = { class: "table__head" }
const _hoisted_3 = { class: "table__head--label" }
const _hoisted_4 = { class: "table__head--action" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["colspan"]
const _hoisted_8 = { class: "no__data--body" }

import {ChevronSelectorVertical, Inbox01} from "utruckin-icons";
import {computed} from "vue";
import {ITableEmits, ITableHeader, ITableProps} from "@/types/table";
import CustomLoading from "@/components/custom/CustomLoading.vue";
import {useStatsStore} from "@/features/stats/stats.store";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonTable',
  props: {
    loading: { type: Boolean, default: false },
    headers: { default: undefined },
    items: { default: undefined },
    striped: { type: Boolean, default: true }
  },
  emits: ["row-clicked", "row-mouseover", "row-mouseout"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

const store = useStatsStore();

const rowClick = (row: any, rowIndex: number, $event: MouseEvent) => {
  emit("row-clicked", row, rowIndex, $event);
};

const checkDisabled = computed(() => {
  return (item: ITableHeader): boolean => {
    if (item.panel && item.panel.length) {
      for (let index = 0; index < item.panel.length; index++) {
        if (store.panels[item.panel[index]]) {
          return true;
        }
      }

      return false;
    }
    return true
  }
})

const getColumnStyle = (header: ITableHeader) => {
  if (header.fitContent) {
    return {
      width: '1%',
      whiteSpace: 'nowrap'
    }
  }

  if (header.width) {
    return {
      width: header.width
    }
  }

  return {
    width: 'auto'
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.loading)
      ? (_openBlock(), _createElementBlock("table", {
          key: 0,
          class: _normalizeClass(["table", {'striped': __props.striped}])
        }, [
          _createElementVNode("colgroup", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (header, index) => {
              return (_openBlock(), _createElementBlock("col", {
                key: index,
                style: _normalizeStyle(getColumnStyle(header))
              }, null, 4))
            }), 128))
          ]),
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (item, index) => {
                return (_openBlock(), _createElementBlock("th", { key: index }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(ChevronSelectorVertical), { size: 12 })
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (__props.items?.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.items, (item, rowIdx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: rowIdx,
                    onClick: (e) => rowClick(item, rowIdx, e)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (cellItem, cellIdx) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: cellIdx,
                        class: _normalizeClass([
                checkDisabled.value(cellItem) ? '' : 'disabled',
                cellItem.type == 'error' ? 'error' : ''
                ])
                      }, [
                        _renderSlot(_ctx.$slots, cellItem.name, {
                          item: item,
                          index: rowIdx
                        }, () => [
                          _createTextVNode(_toDisplayString(item[cellItem.name]), 1)
                        ])
                      ], 2))
                    }), 128))
                  ], 8, _hoisted_5))
                }), 128))
              : (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                  _createElementVNode("td", {
                    class: "no__data",
                    colspan: __props.headers?.length
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_unref(Inbox01), { size: 40 }),
                      _cache[0] || (_cache[0] = _createTextVNode(" Data not found ", -1))
                    ])
                  ], 8, _hoisted_7)
                ]))
          ])
        ], 2))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(7, (n) => {
          return _createVNode(CustomLoading, {
            height: "54px",
            width: "100%",
            key: n,
            style: {"margin-bottom":"8px"}
          })
        }), 64))
  ]))
}
}

})